import { useCallback } from "react";
import { CheckStatus } from "./index";

export const useGroupedVirtualizedAllSelection = <Data>(
  data: readonly Data[],
  isSelected: (item: Data) => boolean,
  addItems: (item: readonly Data[]) => void,
  deleteItems: (item: readonly Data[]) => void
) => {
  const getAllCheckStatus = useCallback(() => {
    let checkStatus = CheckStatus.NONE;
    for (const item of data) {
      checkStatus |= isSelected(item) ? CheckStatus.CHECKED : CheckStatus.UNCHECKED;
    }
    return checkStatus;
  }, [data, isSelected]);

  const addAll = useCallback(() => {
    addItems(data);
  }, [data, addItems]);

  const deleteAll = useCallback(() => {
    deleteItems(data);
  }, [data, deleteItems]);

  return { getAllCheckStatus, addAll, deleteAll };
};
